(function () {

    'use strict';

    angular.module('iplusjs.link', [
        'lodash',
        'iplusjs.config',
        'iplusjs.utils.misc',
        'iplusjs.integration'
    ])
    .directive('a', link);

    link.$inject = [
        '$window',
        'lodash',
        'AppConfig',
        'MiscUtilsService',
        'IntegrationService'
    ];
    function link($window, _, AppConfig, MiscUtilsService, IntegrationService) {
        return {
            restrict: 'E',
            link: function ($scope, $element, $attrs) {
                $element.on('click', function ($event) {
                    var payload,
                        isValidHref = MiscUtilsService.isNotEmpty($attrs.href) && (/^http(s)?:\/\//i).test($attrs.href),
                        confirmUnload = $scope.$eval($attrs.confirmUnload),
                        urlFileEnding,
                        isFile = false;

                    if (confirmUnload === false) {
                        $window.confirmBeforeUnload = false;
                    }

                    if (isValidHref && (!$attrs.target || $attrs.target === '_self')) {
                        if ($window.removePksRedirectInfos !== false) {
                            $window.sessionStorage.removeItem('iframeReload');
                            $window.sessionStorage.removeItem('reload');
                        }
                    }
                    if (!MiscUtilsService.isAppModus()) {
                        return;
                    }

                    if (isValidHref) {
                        $event.preventDefault();

                        if (_.startsWith($attrs.href, AppConfig.APP.urls.kundenportal)) {
                            $window.confirmBeforeUnload = false;

                            payload = {
                                url: _.replace($attrs.href, AppConfig.APP.urls.kundenportal, ''),
                                routingType: 'intern',
                                closeWindow: true
                            };
                        } else {
                            urlFileEnding = $attrs.href.split('/').pop().split('.')[1];

                            if (_.includes([
                                'pdf',
                                'jpg',
                                'jpeg',
                                'png',
                                'tiff'
                            ], _.toLower(urlFileEnding))) {
                                isFile = true;
                            }

                            payload = {
                                url: $attrs.href,
                                routingType: 'extern',
                                isFile: isFile
                            };
                        }

                        IntegrationService.sendMessage(payload, _.get($window, 'webkit.messageHandlers.cordova_iab'));

                        return false;
                    } else {
                        return;
                    }
                });
            }
        };
    }

})();
